
export const GO_BUTTON_API_SAP_LEDGER = "GO_BUTTON_API_SAP_LEDGER"
export const GO_BUTTON_API_SAP_LEDGER_SUCCESS = "GO_BUTTON_API_SAP_LEDGER_SUCCESS"

export const PRODUCTMARGIN_GO_BTN_ACTION = "PRODUCTMARGIN_GO_BTN_ACTION"
export const PRODUCTMARGIN_GO_BTN_SUCCESS = "PRODUCTMARGIN_GO_BTN_SUCCESS"


export const GO_BUTTON_API_SAP_LEDGER_ERROR = "GO_BUTTON_API_SAP_LEDGER_ERROR"
